import { Tabs as MuiTabs, TabsProps as MuiTabsProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Stack from "@rui/Stack";

export type TabsProps = MuiTabsProps & { noTabBackground?: boolean };

export const TabsContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: "#FFF",
  padding: theme.spacing(0, 2.5),
  borderBottom: `2px solid ${theme.palette.shades.neutral[50]}`,
  "& .MuiTabs-root": { marginBottom: "-2px" },
  position: "relative",
}));

const Tabs = styled(({ noTabBackground: _, ...props }: TabsProps) => (
  <MuiTabs {...props} />
))(({ theme }) => ({
  minHeight: "52px",
  "& .MuiTab-root.Mui-selected": {
    background: theme.palette.shades.primary[50],
  },
  [theme.breakpoints.down("sm")]: {
    minHeight: "40px",

    "& .MuiTabs-flexContainer": {
      gap: theme.spaces.small,
    },
  },
}));

export default Tabs;
